<template>
  <div>
    <div class="rj-page-card reconciliationManagement">
      <div class="rj-page-card__title">
        锐捷网络应收款对账单（赊销订单）
      </div>
      <div class="cptMessage">
        <span class="left">合作伙伴：{{ userName }}/{{ userId }}</span>
        <span class="right">对账单日期：{{ reconciliationDate }}</span>
      </div>
      <div class="rj-page-card__content">
        <!-- 合同 -->
        <el-table
          v-loading="isLoading"
          class="tableClass"
          :data="tableData"
          border
          style="width: 100%"
          show-summary
          :summary-method="getSummaries"
        >
          <el-table-column
            prop="custPoNumber"
            label="合同编号"
            align="left" fixed="left"
          />
          <el-table-column prop="projectName" label="项目名称" align="left" fixed="left" />
          <el-table-column label="实际结算金额(元)" align="right" header-align="left">
            <template v-slot="{ row }">
              {{ Number(row.erpActualSettlementAmount).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="hkAmountAll"
            label="已回款金额(元)"
            align="right" header-align="left"
          />
          <el-table-column
            prop="kpAmount"
            label="已开票金额(元)"
            align="right" header-align="left"
          />
          <el-table-column
            prop="jsInvoice"
            label="金税发票号码"
            align="left"
          />
          <el-table-column prop="lastKpDate" label="发票日期" align="left" />
        </el-table>
        <!-- 发货信息 -->
        <el-table
          v-loading="isLoading"
          :data="tableDataSecond"
          show-summary
          :summary-method="getSummariesSecond"
        >
          <el-table-column
            prop="custPoNumber"
            label="合同编号"
            align="left" fixed="left"
            width="200"
          />
          <el-table-column
            prop="projectName"
            label="项目名称"
            align="left" fixed="left"
            width="200"
          />
          <el-table-column label="实际结算金额(元)" align="right" header-align="left">
            <template v-slot="{ row }">
              {{ Number(row.erpActualSettlementAmount).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column prop="zqWz" label="账期天数" align="left" />
          <el-table-column
            prop="fhAmountCj"
            label="分批发货金额(元)"
            align="right" header-align="left"
            width="150"
          />
          <el-table-column
            prop="deliveryDate"
            label="分批发货日期"
            align="left"
            width="100"
          />
          <el-table-column
            prop="yskDate"
            label="应支付日期"
            align="left"
            width="100"
          />
          <el-table-column prop="rate" label="日贴息率" align="right" header-align="left" />
          <el-table-column
            prop="yskAmount"
            label="应支付金额(元)"
            align="right" header-align="left"
            width="150"
          />
          <el-table-column
            prop="txAmount"
            label="贴息金额(元)"
            align="right" header-align="left"
            width="150"
          />
          <el-table-column
            prop="bcYzfAmount"
            label="应支付总额(元)"
            align="right" header-align="left"
            width="150"
          />
        </el-table>
      </div>
      <div class="message">
        注：

        <div>
          1、若对本对账单有疑问，请随时与商务部平台商务专员联系；若无疑问，请签字确认并盖章回传
        </div>

        <div>
          2、自向贵司发出邮件之日起2个工作日，请贵司对本对账单提出异议，由锐捷网络进行审核，如超过2个工作日未提出异议即表示合作伙伴认可本对账单
        </div>

        <div>3、对账数据截止<span style="color:red">{{ endDate }}</span></div>
      </div>
      <div class="endName">
        <div>锐捷网络股份有限公司</div>
        <br>
        <div>{{ bottomDate }}</div>
      </div>
      <div v-if="isShow" style="margin-top: 20px;position: fixed;bottom: 20px;">
        <el-button type="primary" @click="makeManagement">
          生成对账单
        </el-button>
        <el-button :loading="isExportLoading" type="primary" @click="exportStatement">
          导出对账单
        </el-button>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="open">
      <file @status="dialogStatus" />
    </el-dialog>
  </div>
</template>

<script>
import file from './file';
import { getReconciliationInfo, exportBusinessEmailNotificationStatementDetails } from '@/API';
import { MathAdd, downloadBlobFile } from '@/libs/util';
export default {
  data () {
    return {
      isLoading: false,
      tableData: [{
        billTo: 123
      }],
      tableDataSecond: [],
      open: false,
      title: '对账单操作',
      reconciliationDate: '',
      bottomDate: '',
      endDate: '',
      userName: '123',
      userId: '123',
      isExportLoading: false
    };
  },
  components: {
    file
  },
  props: {
    isShow: {
      type: Boolean,
      default: true
    }
  },
  mounted () {
    this.initData();
  },
  methods: {
    // 初始化
    initData () {
      this.isLoading = true;
      let parmas = '';
      if (!this.isShow) {
        parmas = this.$route.query.userId;
        this.userId = this.$route.query.userId;
        this.userName = this.$route.query.userName;
      } else {
        parmas = this.$store.state.user.userId;
        this.userId = this.$store.state.user.userId;
        this.userName = this.$store.state.user.userName;
      }

      getReconciliationInfo({ agentId: parmas }).then((res) => {
        this.isLoading = false;
        const json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.contractInfoList;
          this.tableDataSecond = json.data.fhInfoList;
          this.reconciliationDate = json.data.reconciliationDate;
          this.bottomDate = json.data.bottomDate;
          this.endDate = json.data.endDate;
        }
      }).catch(() => {
        this.isLoading = false;
      });
    },
    // 合计行的计算
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '实际结算金额(元)') {
          sums[index] = this.actualAmount(this.tableData);
        }
        if (column.label === '已回款金额(元)') {
          sums[index] = this.hkAmountAll(this.tableData);
        }
        if (column.label === '已开票金额(元)') {
          sums[index] = this.kpAmount(this.tableData);
        }
      });
      return sums;
    },
    // 合计行的计算
    getSummariesSecond (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '实际结算金额(元)') {
          sums[index] = this.actualAmount(this.tableDataSecond);
        }
        if (column.label === '分批发货金额(元)') {
          sums[index] = this.fhAmountCj(this.tableDataSecond);
        }
      });
      return sums;
    },
    // 实际结算金额(元)
    actualAmount (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.erpActualSettlementAmount);
      });
      // cont = Number(cont).toFixed(2);
      return cont.toFixed(2);
    },
    hkAmountAll (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.hkAmountAll);
      });
      // cont = Number(cont).toFixed(2);
      return cont.toFixed(2);
    },
    kpAmount (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.kpAmount);
      });
      // cont = Number(cont).toFixed(2);
      return cont.toFixed(2);
    },
    fhAmountCj (target) {
      let cont = 0;
      target.forEach((item) => {
        cont = MathAdd(cont, item.fhAmountCj);
      });
      // cont = Number(cont).toFixed(2);
      return cont.toFixed(2);
    },
    makeManagement () {
      this.open = true;
    },
    dialogStatus (val) {
      if (!val) {
        this.open = false;
      }
    },

    // 导出对账单
    exportStatement () {
      this.isExportLoading = true;
      exportBusinessEmailNotificationStatementDetails()
        .then(res => {
          this.isExportLoading = false;
          downloadBlobFile({
            content: res.data,
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            fileName: '导出对账单'
          });
        }).catch(() => {
          this.isExportLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.reconciliationManagement {
  .rj-page-card__title {
    text-align: center;
    font-size: 30px;
    font-weight: 700;
  }
  .cptMessage {
    font-size: 20px;
    font-weight: 700;
    margin: 20px 0;
    width: 100%;
    height: 30px;
    .left {
      float: left;
      display: inline-block;
    }
    .right {
      display: inline-block;
      float: right;
    }
  }
  .rj-page-card__content {
    .tableClass {
      margin: 10px 0;
    }
  }
  .message {
    div {
      margin: 10px;
    }
  }
  .endName {
    width: 100%;
    height: 60px;
    div {
      width: 100%;
      font-size: 20px;
      font-weight: 700;
      text-align: right;
    }
  }
}
</style>
